export default __webpack_public_path__ + "static/media/Vambraces of the Steel Behemoth.b2c50145.jpg";